import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { loginUser, resetPassword } from "../../../redux/auth/actions";
import { useDispatch } from "react-redux";
import { Container, Row, Col, Button, Dropdown, Form } from "react-bootstrap";
import hide from "../../../assets/svg/hide.png";
import EyeIcon from "../../../assets/svg/EyeIcon";
import { APP_CONST, AuthModals } from "../../../config/const";

import { useNavigate } from "react-router-dom";
import { Toaster } from "../../../utils/toaster";
import AppButton from "../Ui/AppButton";

const ResetPassword = ({ show, handleModalChange }) => {
  const dispatch = useDispatch();
  const [otp, setOtpValue] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (otp == "" || password == "") {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "All fields are mandatory");
      return;
    }
    setIsLoading(true);
    const response = await resetPassword({
      otp,
      password,
    });
    setIsLoading(false);
    if (response) {
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Password reset success");
      handleModalChange(AuthModals.Login);
    }
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas login-modal signup-modal"}
      placement={"end"}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        closeButton
        onClick={() => handleModalChange(null)}
        closeVariant="white"
      ></Modal.Header>
      <Modal.Body>
        <div className="login-section">
          <div className="Login-rightPart">
            {/* <Modal.Title>Reset Password</Modal.Title> */}
            <div className="form-steps">
              <h2 className="h2">Reset Password</h2>
              {/* <p>Please enter OTP you received on your mobile number</p> */}
              <Form onSubmit={handleSubmit}>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type="password"
                    placeholder="Enter OTP*"
                    onChange={(e) => setOtpValue(e.target.value)}
                  />
                  <span className="icon" onClick={() => setShowOtp((s) => !s)}>
                    {showOtp ? <img src={hide} alt="" /> : <EyeIcon />}
                  </span>
                </Form.Group>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type="password"
                    placeholder="Enter new password"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span
                    className="icon"
                    onClick={() => setShowPassword((s) => !s)}
                  >
                    {showPassword ? <img src={hide} alt="" /> : <EyeIcon />}
                  </span>
                </Form.Group>
                <AppButton text="Submit" type="submit" isLoading={isLoading} />
              </Form>

              <div className="sign-up mt-4">
                Already a member?
                <br />
                <a 
                  role="button"
                  href="#"
                  onClick={() => {
                    handleModalChange(AuthModals.Login);
                  }}>Log In here</a>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ResetPassword;
